<template>
  <v-container class="mt-0">
      <v-layout row wrap justify-center v-if="loading">
        <v-flex xs12 sm8 md6 class="text-xs-center">
          <v-progress-circular 
          indeterminate 
          color="primary"
          :width="7"
          :size="70"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
        <h1 class="mt-3 text-xs-center">{{ indication.indicationName }}</h1>
        <v-divider></v-divider>
        <template v-if="userIsCreator">
          <v-spacer></v-spacer>
          <app-edit-indication-dialog :indication="indication"></app-edit-indication-dialog>
        </template>
        <v-btn dark flat class="red darken-3" @click="onDeleteIndication(indication)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    //  dialog: false
    }
  },
  props: ['id'],
  methods: {
    onDeleteIndication (indication) {
      console.log('Delete this: ' + JSON.stringify(indication))
      this.$store.dispatch('deleteIndicationData', indication)
      this.$router.push('/indications')
    }
  },
  computed: {
    indication () {
      console.log('CURRENT ITEM: ' + this.id)
      return this.$store.getters.loadedIndication(this.id)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.indication.creatorId
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>


// WEBPACK FOOTER //
// Indication.vue?946fee24